import { AU, HU, PH, US } from 'country-flag-icons/react/3x2'

import useMarkets from 'hooks/useMarkets'
import { getMarketLabel } from 'shared/functions/detectMarket'

const MARKET_FLAGS = { AU, HU, PH, US }

const MarketFlag = ({ market, style, ...props }) => {
  const { getMarket } = useMarkets()

  const Flag = MARKET_FLAGS[market]

  if (!Flag) return null

  return (
    <Flag
      title={getMarketLabel(getMarket(market)) || market}
      style={{ width: 22, height: 'auto', borderRadius: 2, border: '1px solid rgba(0,0,0,0.1)', ...style }}
      {...props}
    />
  )
}

export default MarketFlag
